/**
 * Prefijos telefónicos — Latinoamérica, España, Europa y EEUU/Canadá
 * -----------------------------------------------------------------------------
 * Formato compacto `[ISO, nombre, prefijo]` para no repetir claves 70 veces.
 *
 * No se incluye la bandera: en Windows no existen glifos de bandera en la fuente
 * de emoji, así que 🇨🇴 se dibuja como las letras «CO» y el desplegable acabaría
 * mostrando «CO Colombia +57». Se muestra el nombre y el prefijo, que es lo que
 * el usuario busca y se lee igual en todos los sistemas.
 */

const RAW = [
  // Latinoamérica
  ['CO', 'Colombia', '57'],
  ['AR', 'Argentina', '54'],
  ['BO', 'Bolivia', '591'],
  ['BR', 'Brasil', '55'],
  ['CL', 'Chile', '56'],
  ['CR', 'Costa Rica', '506'],
  ['CU', 'Cuba', '53'],
  ['DO', 'República Dominicana', '1'],
  ['EC', 'Ecuador', '593'],
  ['SV', 'El Salvador', '503'],
  ['GT', 'Guatemala', '502'],
  ['HN', 'Honduras', '504'],
  ['MX', 'México', '52'],
  ['NI', 'Nicaragua', '505'],
  ['PA', 'Panamá', '507'],
  ['PY', 'Paraguay', '595'],
  ['PE', 'Perú', '51'],
  ['PR', 'Puerto Rico', '1'],
  ['UY', 'Uruguay', '598'],
  ['VE', 'Venezuela', '58'],

  // Norteamérica
  ['US', 'Estados Unidos', '1'],
  ['CA', 'Canadá', '1'],

  // Europa
  ['ES', 'España', '34'],
  ['PT', 'Portugal', '351'],
  ['FR', 'Francia', '33'],
  ['IT', 'Italia', '39'],
  ['DE', 'Alemania', '49'],
  ['GB', 'Reino Unido', '44'],
  ['IE', 'Irlanda', '353'],
  ['NL', 'Países Bajos', '31'],
  ['BE', 'Bélgica', '32'],
  ['LU', 'Luxemburgo', '352'],
  ['CH', 'Suiza', '41'],
  ['AT', 'Austria', '43'],
  ['DK', 'Dinamarca', '45'],
  ['SE', 'Suecia', '46'],
  ['NO', 'Noruega', '47'],
  ['FI', 'Finlandia', '358'],
  ['IS', 'Islandia', '354'],
  ['PL', 'Polonia', '48'],
  ['CZ', 'Chequia', '420'],
  ['SK', 'Eslovaquia', '421'],
  ['HU', 'Hungría', '36'],
  ['RO', 'Rumanía', '40'],
  ['BG', 'Bulgaria', '359'],
  ['GR', 'Grecia', '30'],
  ['HR', 'Croacia', '385'],
  ['SI', 'Eslovenia', '386'],
  ['RS', 'Serbia', '381'],
  ['BA', 'Bosnia y Herzegovina', '387'],
  ['ME', 'Montenegro', '382'],
  ['MK', 'Macedonia del Norte', '389'],
  ['AL', 'Albania', '355'],
  ['EE', 'Estonia', '372'],
  ['LV', 'Letonia', '371'],
  ['LT', 'Lituania', '370'],
  ['UA', 'Ucrania', '380'],
  ['BY', 'Bielorrusia', '375'],
  ['MD', 'Moldavia', '373'],
  ['TR', 'Turquía', '90'],
  ['CY', 'Chipre', '357'],
  ['MT', 'Malta', '356'],
  ['AD', 'Andorra', '376'],
  ['MC', 'Mónaco', '377'],
  ['SM', 'San Marino', '378'],
  ['LI', 'Liechtenstein', '423'],
];

export const COUNTRIES = RAW.map(([iso, name, dial]) => ({ iso, name, dial: `+${dial}` }));

export function findCountry(iso) {
  return COUNTRIES.find((country) => country.iso === iso) || null;
}

export default COUNTRIES;
